var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navigation',{attrs:{"menu_items":_vm.menu_items,"appTitle":_vm.appTitle,"logo":_vm.logo,"appDescription":_vm.appDescription}}),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }